/* Yotpo renders asynchronously; hide only an explicit zero-review label. */
(() => {
  let queued = false;
  const update = () => {
    queued = false;
    document.querySelectorAll('.product-form .yotpo-widget-instance').forEach(widget => {
      let zeroReviews = false;
      widget.querySelectorAll('span, a, div, button').forEach(label => {
        if (label.children.length) return;
        const zero = /^\(?0\)?\s+reviews?$/i.test(label.textContent.trim());
        if (zero) {
          zeroReviews = true;
          label.dataset.sgZeroReviews = 'true';
          label.style.setProperty('display', 'none', 'important');
        } else if (label.dataset.sgZeroReviews) {
          delete label.dataset.sgZeroReviews;
          label.style.removeProperty('display');
        }
      });
      const block = widget.closest('.product-form--block') || widget;
      if (zeroReviews) {
        block.dataset.sgZeroRating = 'true';
        block.style.setProperty('display', 'none', 'important');
      } else if (block.dataset.sgZeroRating) {
        delete block.dataset.sgZeroRating;
        block.style.removeProperty('display');
      }
    });
  };
  const observer = new MutationObserver(() => {
    if (!queued) { queued = true; requestAnimationFrame(update); }
  });
  observer.observe(document.body, {childList: true, subtree: true, characterData: true});
  update();
})();
